module.exports = "img/flags/CZ.f8e07d2.png";